module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Stardust.c480566.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Stardust.jpg
// module id = klfK
// module chunks = 0